import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shouye",
  "use": "icon-shouye-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shouye\"><defs><style type=\"text/css\"></style></defs><path d=\"M853.333333 967.111111h-284.444444v-227.555555H455.111111v227.555555H170.666667V415.288889h56.888889V910.222222h170.666666v-227.555555h227.555556v227.555555h170.666666V415.288889h56.888889z\" fill=\"#bfcbd9\" p-id=\"3554\" /><path d=\"M944.355556 574.577778L512 136.533333l-432.355556 438.044445-45.511111-39.822222L512 56.888889l477.866667 477.866667z\" fill=\"#bfcbd9\" p-id=\"3555\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shouye.svg
// module id = IeYc
// module chunks = 212